$(document).ready(function () {
    var wWidth = window.innerWidth;
    if(wWidth <= 500) {
        $(".slick-slider").addClass("slick-dotted");
    }
    $(".slick-slider").slick({
        dots: true,
        infinite: true,
        adaptiveHeight: true,
        customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<a class="dot">'+(parseInt(i)+1)+'</a>';
        },
        responsive: [{
            breakpoint: 300,
            settings: {
                dots: true,
                arrows: false,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1
            } 
        }]
    });
})
